import ReactQuill from 'react-quill';

const Quill = ReactQuill.Quill;

class CustomImageAlignmentModule {
  constructor(quill, options) {
    this.quill = quill;
    this.options = options;
    this.quill.root.addEventListener('click', this.handleClick.bind(this), false);
    this.observer = new MutationObserver(this.handleMutation.bind(this));
  }

  handleClick(event) {
    let image = Quill.find(event.target);
    if (image && image.domNode) {
      // Начинаем наблюдение за изменениями
      this.observer.observe(image.domNode, {
        attributes: true,
        attributeFilter: ['style', 'align'],
      });
    }
  }

  handleMutation(mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes') {
        // Прекращаем наблюдение перед изменением alt, чтобы избежать рекурсии
        observer.disconnect();
        let image = Quill.find(mutation.target);
        let alignStyle = image.domNode.style['float'] || image.domNode.getAttribute('align');

        // Если выравнивание не задано через float или align, проверяем margin
        if (!alignStyle && image.domNode.style.margin === 'auto') {
          alignStyle = 'center';
        }

        if (alignStyle) {
          image.domNode.setAttribute('alt', alignStyle);
        }

        // Возобновляем наблюдение
        observer.observe(image.domNode, {
          attributes: true,
          attributeFilter: ['style', 'align'],
        });
      }
    }
  }
}

export default CustomImageAlignmentModule;
